import Modal from 'LuxKit/Modal/Modal'
import React, { useMemo, useState } from 'react'
import CarHireInsuranceEnhancedProtectionInfo from './CarHireInsuranceEnhancedProtectionInfo'
import CarHireInsuranceLimitedProtectionInfo from './CarHireInsuranceLimitedProtectionInfo'
import useCarHireInsuranceQuote from 'hooks/CarHire/useCarHireInsuranceQuote'
import LoadingAnimation from 'components/Common/Loading/LoadingAnimation'
import Group from 'components/utils/Group'
import { CAR_HIRE_ENHANCED_PROTECTION_REGIONS } from 'constants/config/region'

enum modalSteps {
  FULL_PROTECTION = 'fullProtection',
  LIMITED_PROTECTION = 'limitedProtection',
  CLOSED = 'closed'
}

interface Props {
  offer: App.CarHireOffer;
  pickUpDate: string;
  isEnhancedProtectionSelected: boolean;
  dropOffDate: string;
}

function CarHireInsuranceModal(props: Props) {
  const { offer, pickUpDate, dropOffDate, isEnhancedProtectionSelected } = props
  const [activeStep, setActiveStep] = useState<modalSteps>(isEnhancedProtectionSelected ? modalSteps.FULL_PROTECTION : modalSteps.LIMITED_PROTECTION)
  const [calledFromLimitedProtection, setcalledFromLimitedProtection] = useState(false)

  const hasEnhancedProtection =
    CAR_HIRE_ENHANCED_PROTECTION_REGIONS.includes(offer.pickUp.countryCode) ||
    CAR_HIRE_ENHANCED_PROTECTION_REGIONS.includes(offer.dropOff.countryCode)

  function onFullProtectionClick() {
    setcalledFromLimitedProtection(true)
    setActiveStep(modalSteps.FULL_PROTECTION)
  }

  function onBack() {
    setcalledFromLimitedProtection(false)
    setActiveStep(modalSteps.LIMITED_PROTECTION)
  }

  function getTitle() {
    switch (activeStep) {
      case modalSteps.FULL_PROTECTION:
        return 'Enhanced Protection'
      case modalSteps.LIMITED_PROTECTION:
        return 'Limited Protection'
      default:
        return 'Compare your insurance options?'
    }
  }

  const rateOption = offer.rateOptions[0]

  const insuranceInfoQueryParams: App.CarHireOfferInsuranceQuoteParams = useMemo(() => {
    return {
      availabilityUuid: offer.availabilityUuid,
      passengerName: 'John',
      reference: {
        id: rateOption.id,
        idContext: rateOption.idContext,
        type: rateOption.type,
        dateTime: rateOption.dateTime,
        url: rateOption.url,
      },
    }
  }, [offer, rateOption])

  const insuranceQuote = useCarHireInsuranceQuote(insuranceInfoQueryParams)
  const insuranceQuoteInfo = insuranceQuote.data

  return <Modal
    onBack={calledFromLimitedProtection ? () => onBack() : undefined}
    size="L"
    title={getTitle()}
    isOpen={activeStep !== modalSteps.CLOSED}
    onClose={() => setActiveStep(modalSteps.CLOSED)}
  >
    {insuranceQuote.fetching &&
      <Group direction="vertical" fullWidth horizontalAlign="center" verticalAlign="center" >
        <LoadingAnimation />
      </Group>
    }

    {activeStep === modalSteps.FULL_PROTECTION && insuranceQuoteInfo &&
      <CarHireInsuranceEnhancedProtectionInfo
        carHireSupplier={offer.vendor.name}
        insuranceQuoteInfo={insuranceQuoteInfo}
        hasEnhancedProtection={hasEnhancedProtection}
      />
    }

    {activeStep === modalSteps.LIMITED_PROTECTION &&
      <CarHireInsuranceLimitedProtectionInfo
        onClick={onFullProtectionClick}
        offer={offer}
        pickUpDate={pickUpDate}
        dropOffDate={dropOffDate}
        pickUpTime=""
        dropOffTime=""
        hasEnhancedProtection={hasEnhancedProtection}
      />
    }

  </Modal>
}

export default CarHireInsuranceModal
